import { Injectable } from '@angular/core';
import {CanLoad,Router} from '@angular/router';

import {AuthService} from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanLoad {
  constructor(
    private router: Router,
    private authService: AuthService) {}

  canLoad() {
    if (this.authService.isTokenExpired()) {
      return true;
    }

    this.router.navigate(['/users']);
    return false;
  }
}
